/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Address } from './address';
import { CartItemPopulated } from './cart-item-populated';
import { Discount } from './discount';
import { ObjectId } from './object-id';
import { OrderTimeLineDTO } from './order-time-line-dto';
import { Payment } from './payment';
import { PreferedPickOrDeliveryTimeDto } from './prefered-pick-or-delivery-time-dto';
import { Shipment } from './shipment';
import { ShippingInfo } from './shipping-info';
import { UserWithNoId } from './user-with-no-id';
/**
 * 
 * @export
 * @interface PopulatedOrder
 */
export interface PopulatedOrder {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof PopulatedOrder
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PopulatedOrder
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PopulatedOrder
     */
    id?: string;
    /**
     * 
     * @type {ObjectId}
     * @memberof PopulatedOrder
     */
    userId?: ObjectId;
    /**
     * 
     * @type {string}
     * @memberof PopulatedOrder
     */
    shipmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedOrder
     */
    orderType?: PopulatedOrderOrderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PopulatedOrder
     */
    orderStatus?: string;
    /**
     * Each item includes productVariantData.productName and productVariantData.productId for display
     * @type {Array<CartItemPopulated>}
     * @memberof PopulatedOrder
     */
    items?: Array<CartItemPopulated>;
    /**
     * 
     * @type {number}
     * @memberof PopulatedOrder
     */
    subTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof PopulatedOrder
     */
    tax?: number;
    /**
     * 
     * @type {number}
     * @memberof PopulatedOrder
     */
    shippingCost?: number;
    /**
     * 
     * @type {number}
     * @memberof PopulatedOrder
     */
    grandTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof PopulatedOrder
     */
    discountedAmount?: number;
    /**
     * 
     * @type {ShippingInfo}
     * @memberof PopulatedOrder
     */
    shippingInfo?: ShippingInfo;
    /**
     * 
     * @type {string}
     * @memberof PopulatedOrder
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof PopulatedOrder
     */
    storeId?: string;
    /**
     * 
     * @type {Array<OrderTimeLineDTO>}
     * @memberof PopulatedOrder
     */
    orderTimeLine?: Array<OrderTimeLineDTO>;
    /**
     * 
     * @type {UserWithNoId}
     * @memberof PopulatedOrder
     */
    userData?: UserWithNoId;
    /**
     * 
     * @type {Discount}
     * @memberof PopulatedOrder
     */
    discountsApplied?: Discount;
    /**
     * 
     * @type {Address}
     * @memberof PopulatedOrder
     */
    pickUpAddress?: Address;
    /**
     * 
     * @type {PreferedPickOrDeliveryTimeDto}
     * @memberof PopulatedOrder
     */
    preferedPickOrDeliveryTime?: PreferedPickOrDeliveryTimeDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof PopulatedOrder
     */
    orderRemindingDates?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PopulatedOrder
     */
    customProducts?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PopulatedOrder
     */
    type?: PopulatedOrderTypeEnum;
    /**
     * Shippo rate ID stored for deferred label purchase on Card payments
     * @type {string}
     * @memberof PopulatedOrder
     */
    shippoRateId?: string;
    /**
     * Whether to send an order confirmation email to the customer. Persisted so the invoice.paid webhook can respect it.
     * @type {boolean}
     * @memberof PopulatedOrder
     */
    sendConfirmationEmail?: boolean;
    /**
     * 
     * @type {Payment}
     * @memberof PopulatedOrder
     */
    payment: Payment;
    /**
     * 
     * @type {Shipment}
     * @memberof PopulatedOrder
     */
    shipment?: Shipment;
}

/**
    * @export
    * @enum {string}
    */
export enum PopulatedOrderOrderTypeEnum {
    Pickup = 'Pickup',
    Delivery = 'Delivery'
}
/**
    * @export
    * @enum {string}
    */
export enum PopulatedOrderTypeEnum {
    Quotation = 'Quotation',
    Order = 'Order'
}

